module.exports = __webpack_public_path__ + "img/huilan.1ceb8012.png";